import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ThemePalette } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { faLongArrowAltRight } from '@fortawesome/free-solid-svg-icons';
import { UpdateUser } from 'app/shared/models/Update/updateUser';
import { AuthenticationService } from 'app/shared/services/authentification/authentification.service';
import { DataService } from 'app/shared/services/data/data.service';
import { FfvapiService } from 'app/shared/services/ffvApi/ffvapi.service';
import { UiService } from 'app/shared/services/ui/ui.service';
import { UserService } from 'app/shared/services/user/user.service';

@Component({
  selector: 'app-update-profil',
  templateUrl: './update-profil.component.html',
  styleUrls: ['./update-profil.component.scss'],
  // changeDetection: ChangeDetectionStrategy.OnPush
})
export class UpdateProfilComponent implements OnInit {

  faLongArrowAltRight = faLongArrowAltRight;

  updateUserForm: FormGroup;

  inactive = false;
  loading = false;

  test = false;

  clubs: object;
  userInfos: any;

  linkLicence = false;


  color: ThemePalette = 'primary';
  titleSelected: string;
  password: string;
  updateUser: UpdateUser;


  constructor(
    private dataService: DataService,
    public dialog: MatDialog,
    private formBuilder: FormBuilder,
    private authService: AuthenticationService,
    private uiService: UiService,
    private userService: UserService,
    private ffvService: FfvapiService
  ) { }


  ngOnInit(): void {

    this.checkIfALicence();
    this.getInfoUserToken();
    this.initForm();
    this.getClubs();
  }

  showMyClub(): void {
    this.dataService.showMyClub.next(true);
    this.dataService.showupdateProfil.next(false);
  }

  goBack(): void {
    this.dataService.showupdateProfil.next(false);
  }

  onSubmit(): void {
    if (this.updateUserForm.invalid) {
      this.errorsToManage();
      return;
    }

    this.updateUser = {
      title: null,
      lastName: this.f.lastName.value,
      firstName: this.f.firstName.value,
      dBirth: this.f.dBirth.value,
      email: this.f.email.value,
      club: null,
    };



    this.loading = true;

    this.userService.updateUser(this.updateUser).subscribe(() => {
      this.dataService.showupdateProfil.next(false);
      this.authService.refreshToken().subscribe(() => {
        const userInfo = this.authService.getDecodedToken();
        this.dataService.userLogin.next(userInfo);

      });
    });
  }


  isInactive(inputValue: string): void {
    inputValue ? this.inactive = true : this.inactive = false;
  }

  private getClubs(): void {
  }

  private initForm(): void {
    const date = new Date();


    this.updateUserForm = this.formBuilder.group({
      // title: [''],
      lastName: [`${this.userInfos.family_name}`, Validators.required],
      firstName: [`${this.userInfos.given_name}`, Validators.required],
      email: [`${this.userInfos.email}`],
      dBirth: [date],
    });

    // this.updateUserForm.get('lastName').setValue(this.userInfos.family_name);
    // this.updateUserForm.get('firstName').setValue(this.userInfos.given_name);
    // this.updateUserForm.get('email').setValue(this.userInfos.email);
  }

  private get f() {
    return this.updateUserForm.controls;
  }

  // private openDialog(): void {
  //   const dialogRef = this.dialog.open(ConfirmUpdateUserComponent, {

  //     data: { password: this.password }
  //   });

  //   dialogRef.afterClosed().subscribe(result => {
  //     const pw = this.cryptPassword.cryptPassword(result);
  //     this.updateUser.password = pw;
  //     this.userService.updateUser(this.updateUser).subscribe(() => {
  //       this.dataService.showupdateProfil.next(false);
  //       this.authService.refreshToken().subscribe();
  //     });
  //   });
  // }

  private getInfoUserToken(): void {
    this.userInfos = this.authService.getDecodedToken();
    // this.updateUserForm.get('title').setValue(this.userInfos.title);

    // this.updateUserForm.get('club').setValue(this.userInfos.club);
  }

  private errorsToManage(): void {
    // const title = this.f.title.errors?.required;
    const lastName = this.f.lastName.errors?.required;
    const firstName = this.f.firstName.errors?.required;
    const dBirth = this.f.dBirth.errors?.required;
    const email = this.f.email.errors?.required;
    // const club = this.f.club.errors?.required;

    const check = lastName && firstName && dBirth && email;

    // if (title) {
    //   this.uiService.openSnackBar(`Champ Titre requis`, '');
    // }
    if (lastName) {
      this.uiService.openSnackBar(`Champ Nom requis`, '');
    }
    if (firstName) {
      this.uiService.openSnackBar(`Champ Prénom requis`, '');
    }
    if (dBirth) {
      this.uiService.openSnackBar(`Champ Date anniversaire requis`, '');
    }
    if (email) {
      this.uiService.openSnackBar(`Champ Email requis`, '');
    }
    // if (club) {
    //   this.uiService.openSnackBar(`Champ Club requis`, '');
    // }
    if (check) {
      this.uiService.openSnackBar(`Les champs sont vides`, '');
    }
  }

  private checkIfALicence(): void {
    this.ffvService.checkIfALicence().subscribe(res => {
      this.linkLicence = true;
    }, error => {
      this.linkLicence = false;
    });
  }
}
